// EsimService.js

import { getAxiosInstance } from "./axiosInstance";

const uploadEsimExcel = (formData) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/esimdata/upload/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const getEsimList = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/esimdata/list/",
    data
  );
};

const updateEsim = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/esimdata/update/",
    data
  );
};

const eSimServices = {
  uploadEsimExcel,
  getEsimList,
  updateEsim,
};
export default eSimServices;